// extracted by mini-css-extract-plugin
export var bodyRow = "_er-d";
export var cardColumns = "_er-e";
export var ellipsesOverflow = "_er-2";
export var flatBottomCorners = "_er-3";
export var flatTopCorners = "_er-4";
export var headerActionsDropdown = "_er-f";
export var headerBottomRow = "_er-c";
export var headerTopRow = "_er-b";
export var orderDetailsWrapper = "_er-0";
export var orderInfoContainer = "_er-1";
export var productDetails = "_er-9";
export var productImage = "_er-5";
export var responsiveTable = "_er-8";
export var shipmentContainer = "_er-a";
export var tableBottomLeft = "_er-6";
export var tableBottomRight = "_er-7";